const SMU_TOKEN = "smu-token";
const SMU_USER = "smu-user";
const SMU_INDEX_PATH = "smu-index-path";

export { SMU_TOKEN, SMU_USER, SMU_INDEX_PATH };
